import UserService from "../../services/UserService";

const RenderOnAuthenticated = ({ children }) => {
    return (UserService.isLoggedIn()) ? children : null;
}
    

export default RenderOnAuthenticated
